import type { BadgesResponse } from "@/api/schemas/badges";
import type { DestinoId } from "@/routes/routeConfig";

export interface NavBadge {
  count?: number;
  /** Texto accesible del contador: el número solo no dice qué cuenta. */
  countText?: string;
  dot?: "red" | "amber";
  dotText?: string;
}

/**
 * Contadores de la navegación (interaction.md §1.2). Siempre llevan texto accesible, nunca solo color o número.
 * Propuestas cuenta pendientes (rojo si alguna es crítica); Conexiones avisa si una cuenta falla o pide
 * revisión; WhatsApp cuenta chats sin leer. Leads, Citas y «no cubre costes» llegan con sus pantallas.
 */
export function deriveNavBadges(badges: BadgesResponse | undefined, unreadChats: number): Partial<Record<DestinoId, NavBadge>> {
  const result: Partial<Record<DestinoId, NavBadge>> = {};
  if (unreadChats > 0) result.whatsapp = { count: unreadChats, countText: "chats sin leer" };
  if (!badges) return result;
  if (badges.proposals.pending > 0 || badges.proposals.critical > 0) {
    result.propuestas = {
      count: badges.proposals.pending > 0 ? badges.proposals.pending : undefined,
      countText: badges.proposals.pending > 0 ? "propuestas pendientes" : undefined,
      dot: badges.proposals.critical > 0 ? "red" : undefined,
      dotText: badges.proposals.critical > 0 ? "Hay propuestas urgentes" : undefined,
    };
  }
  if (badges.connections.level === "error") result.conexiones = { dot: "red", dotText: "Alguna conexión falla" };
  else if (badges.connections.level === "warn") result.conexiones = { dot: "amber", dotText: "Alguna conexión necesita revisión" };
  return result;
}
